import React from "react";
import { Box, Chip, CircularProgress, Tooltip } from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface SessionSyncBadgeProps {
  progress?: number;
  total?: number;
  isCompleted?: boolean;
  isSyncing?: boolean;
}

export const SessionSyncBadge: React.FC<SessionSyncBadgeProps> = ({
  progress = 0,
  total = 0,
  isCompleted = false,
  isSyncing = false,
}) => {
  // Don't show badge if sync is completed
  if (isCompleted || (!isSyncing && progress === 0)) {
    return null;
  }

  const progressPercent = total > 0 ? Math.round((progress / total) * 100) : 0;

  return (
    <Tooltip
      title={
        isSyncing
          ? `Syncing conversations: ${progress}/${total} (${progressPercent}%)`
          : "Full Sync"
      }
      arrow
    >
      <Chip
        icon={
          isSyncing ? (
            <CircularProgress size={16} sx={{ color: "white" }} />
          ) : (
            <CheckCircleIcon sx={{ fontSize: 16 }} />
          )
        }
        label={isSyncing ? `${progress}/${total}` : "Completo"}
        size="small"
        sx={{
          backgroundColor: isSyncing ? "#7C4DFF" : "#4CAF50",
          color: "white",
          fontWeight: 600,
          fontSize: "0.75rem",
          height: "24px",
          "& .MuiChip-icon": {
            color: "white",
          },
        }}
      />
    </Tooltip>
  );
};
